import React, {useContext} from "react"
import {TransactionDate} from "./transaction-date/transaction-date"
import {TransactionAmountAlignedRight, TransactionImpactAlignedRight} from "./transaction-amount/transaction-amount"
import {Transaction} from "../../../domain/transaction"
import {CategoryHelper, CategoryHelperContext} from "../../../services/helpers/category-helper"
import styles from "./transactions-list.module.scss"
import {SortOn, SortOptions} from "../../../services/api/transactions-api"
import {Button} from "../../../components-shared/button/button"
import {Category} from "../../../components-shared/category/category"
import {SortIndicator} from "../../../components-shared/sort-indicator/sort-indicator"

export interface TransactionsListProps {
  transactions: Transaction[]
  sortOn?: SortOn
  changeSort?: (sort: SortOptions) => void
  clickTransaction?: (transaction: Transaction) => void
  impactFirst?: boolean
}

export const TransactionsList: React.FC<TransactionsListProps> = ({transactions, sortOn, changeSort, clickTransaction, impactFirst}) => {
  const categoryHelper = useContext<CategoryHelper | null>(CategoryHelperContext)

  if (!transactions || !categoryHelper) return null
  if (changeSort !== undefined && sortOn === undefined) throw new Error("sortOn should be provided if changeSort is provided")

  return (
    <table className={styles.Transactions} data-hj-suppress={true}>
      <thead>
        <tr>
          <th className={styles.Date}>
            {changeSort === undefined
              ? "datum"
              : <Button onClick={() => changeSort("date")}>datum <SortIndicator descending={sortOn?.sortDesc} display={sortOn?.sort === "date"}/></Button>}
          </th>
          <th>
            <span className={styles.SmallView}>
              {changeSort === undefined
                ? "datum"
                : <Button onClick={() => changeSort("date")}>datum <SortIndicator descending={sortOn?.sortDesc} display={sortOn?.sort === "date"}/></Button>}
                &nbsp;en&nbsp;
            </span>
            {changeSort === undefined
              ? "omschrijving"
              : <Button onClick={() => changeSort("description")}>omschrijving <SortIndicator descending={sortOn?.sortDesc} display={sortOn?.sort === "description"}/></Button>}
          </th>
          <th className={`${styles.Amount} ${styles.LastColumn}`}>
            {changeSort === undefined
              ? "bedrag"
              : <Button onClick={() => changeSort(impactFirst ? "impact" : "amount")}>{impactFirst ? "impact" : "bedrag"} <SortIndicator descending={sortOn?.sortDesc} display={sortOn?.sort === (impactFirst ? "impact" : "amount")}/></Button>}
          </th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((t, i) =>
          <tr key={i} className={clickTransaction === undefined ? "" : styles.ClickableRow} onClick={clickTransaction === undefined ? undefined : () => clickTransaction(t)}>
            <td className={styles.Date}><TransactionDate dateValue={t.date}/></td>
            <td>
              <div className={styles.SmallView}>
                <TransactionDate mobile dateValue={t.date}/>
              </div>
              {t.name}
              <div className={styles.Description}>{t.description}</div>
              <div className={styles.Category}><Category id={t.categoryId}/></div>
            </td>
            <td className={`${styles.TransactionAmount} ${styles.LastColumn}`}>
              <div className={styles.AmountAndImpact}>
                {impactFirst
                  ? <>
                    <TransactionImpactAlignedRight impact={t.co2InKg}/>
                    <TransactionAmountAlignedRight amount={t.amount} secondary/>
                  </>
                  : <>
                    <TransactionAmountAlignedRight amount={t.amount}/>
                    <TransactionImpactAlignedRight impact={t.co2InKg} secondary/>
                  </>}
              </div>
            </td>
          </tr>)
        }
      </tbody>
    </table>)
}